import React from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { cn } from "../../../helpers/utils";
import { FaChevronDown } from "react-icons/fa";

export const UserLanguageDropdown = ({ isDialog }) => {
  const { i18n } = useTranslation();

  // Get current language from i18n (which is now initialized with cookies)
  const currentLang = i18n.language;

  const LANGUAGES = [
    { value: "en", label: "English", icon: "gb" },
    { value: "fr", label: "French", icon: "fr" },
    // { value: "tr", label: "Turkish", icon: "tr" },
  ];

  const handleLanguageChange = (lang) => {
    Cookies.set("lang", lang.value, { path: "/", expires: 365 });
    i18n.changeLanguage(lang.value);
  };

  return (
    <Menu
      as="div"
      className={cn(
        "relative inline-block text-left z-10",
        isDialog ? "w-full mt-2" : "my-2.5"
      )}
    >
      <MenuButton
        className={cn(
          "flex items-center",
          !isDialog
            ? "mr-3 rounded-full"
            : "py-2 px-3.5 border border-primary w-full rounded-lg"
        )}
      >
        <span className="flex items-center justify-center rounded-full overflow-hidden md:text-[24px] text-[17px] md:-mt-1">
          <i
            className={` fis fi fi-${
              LANGUAGES.find((l) => l.value === currentLang)?.icon
            }`}
          />
        </span>
        {isDialog && (
          <>
            <span className="ml-2 text-primary text-sm">
              {LANGUAGES.find((l) => l.value === currentLang)?.label}
            </span>
            <FaChevronDown className="ml-auto" />
          </>
        )}
      </MenuButton>
      <MenuItems
        className={cn(
          "z-10 mt-2 origin-top-right rounded-md bg-primary-dark shadow-lg focus:outline-none",
          !isDialog
            ? "absolute right-0"
            : "bg-[#333333] border border-primary rounded-md w-full py-2"
        )}
      >
        {LANGUAGES.map((item) => (
          <MenuItem
            as="button"
            key={item.value}
            onClick={() => handleLanguageChange(item)}
            className="sm:border-b border-white border-opacity-10 w-full flex items-center gap-2 my-1 md:px-3 px-4 hover:text-primary"
          >
            <span className="flex items-center justify-center rounded-full overflow-hidden md:text-[22px] text-[17px]">
              <i className={` group-hover:text-white fis fi fi-${item.icon}`} />
            </span>
            <span className="flex items-center text-[14px] h-[34px] text-white/70 ">
              {item.label}
            </span>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};
